import React, { useState, useEffect } from "react";
import { ChevronRight } from "lucide-react";
import { MdOutlineMenu } from "react-icons/md";
import { HiOutlineX } from "react-icons/hi";
import ServiceTypesConfiguration from "../AdminConfigurationPage/ServiceTypesConfiguration";
import AboutUsSettings from "./EditAboutUs";
import EditVendorsReview from "./EditVendorsReview";
import EditFaqs from "./EditFaqs";
import EditAdvantages from "./EditAdvantages";
import EditTermsAndconditions from "./EditTermsAndconditions";
import EditImprintandData from "./EditImprintandData";
import EditPrivacyPolicy from "./EditPrivacyPolicy";
import EditCredentials from "./EditCredentials";
import EditBannerDetail from "./EditBannerDetail";

const LayoutSettingsPage: React.FC = () => {
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const layoutSettingsOptions = [
    {
      title: "About Us",
      id: 1,
    },
    {
      title: "Credentials",
      id: 2,
    },
    {
      title: "FAQ",
      id: 3,
    },
    {
      title: "Advantages",
      id: 4,
    },
    {
      title: "Privacy Policy",
      id: 5,
    },
    {
      title: "Imprint and Data",
      id: 6,
    },
    {
      title: "Terms and Conditions",
      id: 7,
    },
    {
      title: "Banner Detail",
      id: 8,
    },
  ];

  // Add click outside handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isSidebarOpen && window.innerWidth <= 1523) {
        const sidebar = document.getElementById("layout-sidebar");
        const menuButton = document.getElementById("layout-menu-button");

        if (
          sidebar &&
          menuButton &&
          !sidebar.contains(event.target as Node) &&
          !menuButton.contains(event.target as Node)
        ) {
          setIsSidebarOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSidebarOpen]);

  return (
    <div className="">
      <div className="bg-bgColor max-h-screen">
        <div className="flex px-6 border-t w-full relative">
          <button
            id="layout-menu-button"
            className="hidden max-[1523px]:block absolute top-4 left-4"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <MdOutlineMenu className="w-6 h-6" />
          </button>

          <div
            id="layout-sidebar"
            className={`col-span-2 pt-2 min-w-48 px-2 max-[1523px]:fixed max-[1523px]:left-0 max-[1523px]:top-0 max-[1523px]:bg-white max-[1523px]:h-screen max-[1523px]:overflow-y-auto max-[1523px]:z-50 max-[1523px]:shadow-lg ${
              isSidebarOpen
                ? "max-[1523px]:translate-x-0"
                : "max-[1523px]:-translate-x-full"
            } transition-transform duration-300 ease-in-out`}
          >
            <div className="flex justify-end">
              <button
                className="hidden max-[1523px]:block pl-2"
                onClick={() => setIsSidebarOpen(false)}
              >
                <HiOutlineX className="w-6 h-6 text-customGray" />
              </button>
            </div>

            <div className="w-full">
              {layoutSettingsOptions.map((option) => (
                <div
                  key={option.id}
                  className="flex items-center justify-between py-3"
                >
                  <span
                    className={`cursor-pointer flex justify-between w-full text-sm font-normal ${
                      selectedButtonIndex === option.id
                        ? "text-customGreenColor font-helveticaMedium"
                        : "text-customGrayDark"
                    }`}
                    onClick={() => {
                      setSelectedButtonIndex(option.id);
                      setIsSidebarOpen(false);
                    }}
                  >
                    <span className="text-left">{option.title}</span>
                    <ChevronRight
                      className="mt-[0.2rem] w-4 h-4"
                      color={
                        selectedButtonIndex === option.id
                          ? "#008000"
                          : "#BEC0CA"
                      }
                    />
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="pt-2 w-full pl-6">
            {selectedButtonIndex === 1 ? (
              <AboutUsSettings />
            ) : selectedButtonIndex === 2 ? (
              <EditCredentials />
            ) : selectedButtonIndex === 3 ? (
              <EditFaqs />
            ) : selectedButtonIndex === 4 ? (
              <EditAdvantages />
            ) : selectedButtonIndex === 5 ? (
              <EditPrivacyPolicy />
            ) : selectedButtonIndex === 6 ? (
              <EditImprintandData />
            ) : selectedButtonIndex === 7 ? (
              <EditTermsAndconditions />
            ) : selectedButtonIndex === 8 ? (
              <EditBannerDetail />
            ) : (
              <AboutUsSettings />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutSettingsPage;
